import {Component, Vue} from 'vue-property-decorator';

@Component({})
export default class IconCache extends Vue {
	storageCache: string | null = typeof window !== 'undefined' ?/* localStorage.getItem('icons')*/ null : null;

	get iconCache(): Map<string, string> {
		return this.$store.state.iconCache;
	}

	static setStorageCache(cache: Map<string, string>): void {
		const storageCache: { [key: string]: string } = {};
		const iterator = cache.entries();

		for (let i = 0; i < cache.size; i++) {
			const [name, value] = iterator.next().value;
			storageCache[name] = value;
		}

		if (typeof window !== 'undefined') {
			//localStorage.setItem('icons', JSON.stringify(storageCache));
		}
	}

	async created(): Promise<void> {
		if (!this.storageCache) {
			return;
		}

		const parsedCache = JSON.parse(this.storageCache);

		for (const name of Object.keys(parsedCache)) {
			await this.$store.dispatch('addIcon', {name, value: parsedCache[name]});
		}
	}
}
